module.exports = __webpack_public_path__ + "static/media/image20.585abe4c.png";